export default (
  state = {
    default: {
      tradeMenu: { label: '', items: [], bottom: [] },
      categoryMenu: { menus: [] }
    }
  },
  action
) => ({ ...state })



// WEBPACK FOOTER //
// ./src/App/MainMenu/reducer.js